/*
Constants describing user authored content types.

These are the different kinds of things one can put in a "scratchpad" that is
editable by a user -- processing.js, SQL, a webpage, or a document.
*/
import {t} from "@lingui/core/macro";

// NOTE(pamela): This functionality is moving from python. It is not fully ported yet.

const USER_AUTHORED_CONTENT_TYPES = Object.freeze({
    PJS: "pjs",
    WEBPAGE: "webpage",
    SQL: "sql",
    PYTHON: "python",
});

export type UserAuthoredContentType =
    (typeof USER_AUTHORED_CONTENT_TYPES)[keyof typeof USER_AUTHORED_CONTENT_TYPES];

type TermMap = {
    new: string;
    restart: string;
    code?: string;
};

export function getTermMap(contentType: UserAuthoredContentType): TermMap {
    switch (contentType) {
        case USER_AUTHORED_CONTENT_TYPES.PJS:
        case USER_AUTHORED_CONTENT_TYPES.PYTHON:
            return {
                new: t`New program`,
                restart: t`Restart`,
            };
        case USER_AUTHORED_CONTENT_TYPES.WEBPAGE:
            return {
                new: t`New webpage`,
                restart: t`Reload`,
                code: `<!DOCTYPE html>
<html>
    <head>
        <meta charset="utf-8">
        <title>${t`New webpage`}</title>
    </head>
    <body>


    </body>
</html>`,
            };
        case USER_AUTHORED_CONTENT_TYPES.SQL:
            return {
                new: t`New SQL script`,
                restart: t`Re-run`,
            };
    }
    return {
        new: "",
        restart: "",
    };
}
